import { Button, Separator, Stack, Text, useDisclosure } from "@chakra-ui/react"
import { Parts, UI } from "components"
import useUser from "hooks/useUser"

export default function SecurityCode(){

    const user = useUser()
    const configure = useDisclosure()

    const hasCode = user.data?.has_security_code

    return(
    <>
    <Parts.Dialog.SecurityCode.Configure {...configure} />
    <UI.Box backgroundColor={hasCode ? 'bg.subtle' : 'red.subtle'}>
        <Stack gap={4}>
            <Text color="GrayText">Código de segurança:</Text>
            <UI.Alert size="sm" colorPalette="gray">O código de segurança (antiga senha financeira) é requerido em várias ações no seu escritório, principalmente financeiras, como pagamentos de terceiros e ativações.</UI.Alert>
            
            <Separator />

            <UI.Show visible={!hasCode}>
                <UI.Alert indicator={<UI.Icon name="key" />} status="error" title="Configure seu código" size="sm">O seu código de segurança não foi configurado. Por favor, crie um agora.</UI.Alert>
                <Button colorPalette="yellow" onClick={configure.onOpen}><UI.Icon name="key" /> Criar código</Button>
            </UI.Show>

            <UI.Show visible={!!hasCode}>
                <UI.Alert indicator={<UI.Icon name="key" />} size="sm" status="success">O seu código de segurança já foi definido por você. Caso queira redefinir seu código de segurança, contate o suporte.</UI.Alert>
                <Button disabled variant="outline" colorPalette="yellow"><UI.Icon name="key" /> Criar código</Button>
            </UI.Show>
        </Stack>
    </UI.Box>
    </>
    )
}